module.exports = "/_next/static/images/apple-store-button-e7347c12ea801b22d7d6312540207786.svg";